/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Feb 11 2025
 **/

import { _T } from "@rfice/language";
import { useWhiteboardActions } from "@rfice/whiteboard";

import { useProperties } from "@/frameworks/libraries/properties";
import { useToast } from "@/frameworks/designStuff";
import { useModal, Button } from "@/frameworks/designStuff/components";
import { ModalID } from "@/frameworks/core/commons";
import useWhiteboardStore from "@/modules/whiteboard/store/useWhiteboardStore";

export interface UploadToWhiteboardButtonProps {
	file: Required<FileBox.Folders.GetFolderFileListResponse>["content"][number];
	size: "XXlarge" | "Xlarge";
	fill?: keyof Colors;
}

export default function UploadToWhiteboardButton({ file, size, fill }: UploadToWhiteboardButtonProps) {
	const setDebugFileInfo = useWhiteboardStore((state) => state.setDebugFileInfo);
	const whiteboardActions = useWhiteboardActions();
	const properties = useProperties();
	const modal = useModal();
	const toast = useToast();

	const uploadFile = (file: SwaggerFileAPIModels.FileBoxResponse) => {
		if (isImageFile(file.fileMimeType)) {
			modal.hide(ModalID.FILE_BOX);
			whiteboardActions.setSelectedFilePath(`${properties.default.webDomain}${file.filePath}`);
		} else {
			toast.show({ type: "error", message: _T("이미지 파일만 업로드 가능합니다.") });
		}
		// for debugging
		setDebugFileInfo(properties.default.webDomain, file);
	};

	/* Utils */
	const isImageFile = (fileMimeType: string | undefined) => {
		return fileMimeType == "image/png" || fileMimeType == "image/jpeg" || fileMimeType == "image/jpg";
	};

	return (
		<Button.Icon
			name="Svg3Dshare24"
			size={size}
			filled="transparent"
			fill={fill}
			onClick={() => uploadFile(file)}
		/>
	);
}
